angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.synchronizationDetailsController', ['$scope', 'platformWebApp.bladeNavigationService', 'virtoCommerce.marketplaceModule.webApi', 'platformWebApp.settings',
        function ($scope, bladeNavigationService, marketplaceApi, settings) {
            var blade = $scope.blade;
            blade.headIcon = 'fas fa-repeat';
            blade.isLoading = false;

            $scope.$on("new-notification-event", function (event, notification) {
                if (blade.notification && notification.id == blade.notification.id) {
                    let jobId = blade.notification.jobId;
                    blade.errorsCount = notification.errors.length;
                    blade.progressPercentage = notification.processedCount / notification.totalCount * 100;
                    angular.copy(notification, blade.notification);
                    if (jobId) {
                        blade.notification.jobId = jobId;
                    }
                    if (notification.finished) {
                        processSyncStats();
                        if (blade.parentRefresh) {
                            blade.parentRefresh();
                        }
                    }
                }
            });

            blade.cancelSync = function () {
                marketplaceApi.syncCancel({ jobId: blade.notification.jobId });
            };

            blade.toolbarCommands = [{
                name: "marketplace.commands.cancel",
                icon: 'fa fa-close',
                executeMethod: blade.cancelSync,
                canExecuteMethod: isSyncRun
            }];

            function isSyncRun() {
                return blade.notification && !blade.notification.finished;
            }

            function processSyncStats() {
                let importStats = [];
                if (blade.notification.importStats && blade.notification.importStats.length > 0) {
                    importStats = groupBy(blade.notification.importStats, 'syncClientName');
                }
                
                let exportStats = [];
                if (blade.notification.exportStats && blade.notification.exportStats.length > 0) {
                    exportStats = groupBy(blade.notification.exportStats, 'syncClientName');
                }

                blade.importStats = importStats;
                blade.exportStats = exportStats;
            }

            function groupBy(arr, prop) {
                let result = [];
                if (arr) {
                    let keys = arr.map(x => x[prop]).filter((value, index, self) => self.indexOf(value) === index);
                    keys.forEach(x => result.push({
                        key: x,
                        value: arr.filter(y => y[prop] === x).map(y => {
                            let statText = y.syncItemName + ": " + y.processedCount + " of " + y.totalCount + " processed";
                            if (y.errorsCount > 0) {
                                statText = statText + " with " + y.errorsCount + " errors";
                            }
                            return statText;
                        })
                    }));
                }
                return result;
            }

            $scope.setForm = function (form) { $scope.formScope = form; };

        }
    ]);
